export default __webpack_public_path__ + "static/media/In_Person_Icon.303e476d.png";